import { GameState } from '../game/GameState';

/**
 * UI component for displaying economy information (gold)
 */
export class EconomyUI {
  private element: HTMLElement;
  private gameState: GameState;
  private lastGold: number = 0;
  
  constructor() {
    this.gameState = GameState.getInstance();
    
    console.log('EconomyUI: Initializing UI component');
    
    // Create UI element
    this.element = this.createUIElement();
    
    // Add to DOM
    document.body.appendChild(this.element);
    
    console.log('EconomyUI: Element created and added to DOM');
  }
  
  /**
   * Create the UI element
   */
  private createUIElement(): HTMLElement {
    const element = document.createElement('div');
    
    // Set ID for potential styling
    element.id = 'economy-ui';
    
    // Style the container
    element.style.position = 'absolute';
    element.style.top = '10px';
    element.style.right = '10px';
    element.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    element.style.color = 'white';
    element.style.padding = '10px 15px';
    element.style.borderRadius = '5px';
    element.style.fontFamily = 'Arial, sans-serif';
    element.style.fontSize = '18px';
    element.style.fontWeight = 'bold';
    element.style.textAlign = 'right';
    element.style.zIndex = '1000';
    
    // Initial content
    element.innerHTML = '💰 0';
    
    return element;
  }
  
  /**
   * Update the UI
   */
  public update(): void {
    // Get current gold
    const gold = this.gameState.getGold();
    
    // Only update DOM if values have changed
    if (this.lastGold !== gold) {
      // Update the element
      this.element.innerHTML = `💰 ${gold}`;
      
      // Store values to avoid unnecessary DOM updates
      this.lastGold = gold;
    }
  }
} 